import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Videopage.css";

const VideoPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { videoSrc, videoTitle } = location.state || {};
  const [isLoading, setIsLoading] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Attempt to autoplay the video once it's loaded
    if (!isLoading && videoRef.current) {
      const iframe = videoRef.current;
      const src = iframe.src;
      // Ensure autoplay and mute parameters are set
      if (!src.includes("autoplay=1")) {
        iframe.src = `${src}${src.includes("?") ? "&" : "?"}autoplay=1&mute=1`;
      }
    }
  }, [isLoading]);

  if (!videoSrc) {
    return (
      <div className="media-view">
        <p className="error-text">
          Video not found! Please select a valid video.
        </p>
      </div>
    );
  }

  return (
    <div className="media-container">
      <button
        className="navigation-back"
        onClick={() => navigate(-1)}
        aria-label="Return to previous page"
      >
        ←
      </button>

      <div className="media-content">
        {isLoading ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Loading video...</p>
          </div>
        ) : (
          <>
            <div className="media-player">
              <iframe
                ref={videoRef}
                className="video-frame"
                src={`${videoSrc}${videoSrc.includes("?") ? "&" : "?"}autoplay=1&mute=1`}
                title={videoTitle}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <h1 className="media-title">{videoTitle}</h1>
          </>
        )}
      </div>
    </div>
  );
};

export default VideoPage;